import { Layout, Tag, Tooltip, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getAIStatusApi } from "../../services/aiStatus.service";
import { useEffect } from "react";
import { storeAiStatus } from "../../store/slices/profile.slice";
import { setCurrentPlan, setPlanLoading, setIsPaidPlan } from "../../store/slices/currentPlan.slice";
import logoImg from "../../assets/images/eko-favicon.png";
import { getPaidStatusApi } from "../../services/credit.service";

const { Header } = Layout;

const AppHeader = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { aiStatus, userData } = useAppSelector((state) => state.profile);
  const { currentPlan, loading } = useAppSelector((state) => state.currentPlan);
  const tenant_label = userData?.tenant_label || localStorage.getItem("tenant_label");
  const isAdmin = (userData?.role || localStorage.getItem("role")) === "admin";
  const resolvedPlan = currentPlan || "TRIAL";
  const planTone = loading ? "is-loading" : resolvedPlan === "PRO" ? "is-pro" : "is-trial";
  const isLive = Boolean(aiStatus);

  useEffect(() => {
    dispatch(
      getAIStatusApi({
        finalCallback: () => {},
        successCallback: (response) => {
          dispatch(storeAiStatus(response?.is_currently_enabled));
        },
        failureCallback: () => {},
      })
    );

    dispatch(
      getPaidStatusApi({
        finalCallback: () => {},
        successCallback: (response) => {
          // Handle different response structures
          let isPaid = false;
          if (typeof response === 'boolean') {
            isPaid = response;
          } else if (typeof response === 'object') {
            // Check common patterns
            isPaid = Boolean(response.paid || response.isPaid || response.status || response.data || response);
          } else {
            isPaid = Boolean(response);
          }

          dispatch(setIsPaidPlan(isPaid));
          dispatch(setCurrentPlan(isPaid ? 'PRO' : 'TRIAL'));
          dispatch(setPlanLoading(false));
        },
        failureCallback: () => {
          dispatch(setPlanLoading(false));
        },
      })
    );
  }, []);

  //   {loading ? "true" : "false"}
  // {currentPlan}

  return (
    <Header className="protected-header">
      <div className="header-left">
        <Button
          className="mobile-drawer-toggle"
          icon={<MenuOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          type="text"
          aria-label="Toggle navigation"
        />
        <div
          className="header-logo tour-logo"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          <img
            src={logoImg}
            alt="EKO logo"
            className="header-logo__img"
          />
          <div className="header-logo__text">
            <span className="header-logo__title">EKO</span>
            {tenant_label && (
              <Tag className="header-logo__tag">
                {tenant_label}
              </Tag>
            )}
          </div>
        </div>
      </div>

      <div className="header-actions">
        <Tooltip title={loading ? "Loading plan status" : `Current plan: ${resolvedPlan}`}>
          <button
            type="button"
            className={`header-plan tour-trial-button ${planTone}`}
            onClick={() => {
              navigate("/settings?tab=billing-usage");
            }}
            aria-label={loading ? "Loading plan status" : `Current plan: ${resolvedPlan}`}
          >
            {loading ? (
              <span className="header-plan__spinner">
                <iconify-icon icon="eos-icons:loading" width="18" height="18" class="rotate-animation"></iconify-icon>
              </span>
            ) : resolvedPlan === "PRO" ? (
              <>
                <span className="header-plan__icon">
                  <iconify-icon icon="fluent:premium-32-filled" width="18" height="18"></iconify-icon>
                </span>
                <span className="header-plan__text">PRO</span>
              </>
            ) : (
              <>
                <span className="header-plan__icon">
                  <iconify-icon icon="mdi:currency-usd-off" width="18" height="18"></iconify-icon>
                </span>
                <span className="header-plan__text">TRIAL</span>
              </>
            )}
          </button>
        </Tooltip>

        <Tooltip title={`AI is ${isLive ? "Live" : "Offline"}`}>
          <button
            type="button"
            className={`header-status tour-ai-status ${isLive ? "is-live" : "is-offline"} ${isAdmin ? "is-clickable" : ""}`}
            onClick={() => {
              if (isAdmin) {
                navigate("/settings?tab=ai-settings#ai-settings-section");
              }
            }}
            disabled={!isAdmin}
            aria-label={`AI status: ${isLive ? "Live" : "Offline"}`}
          >
            <span className="header-status__dot" />
            <span className="header-status__text">{isLive ? "Live" : "Offline"}</span>
          </button>
        </Tooltip>
      </div>
    </Header>
  );
};

export default AppHeader;
